<script setup lang="ts">
/** The Health Check side panels, mounted once in the app shell for issues opened outside Health Check (stores/issue-panel). */
import { computed } from 'vue';
import type { HealthIssue } from '@codot/contracts';
import { openIssue } from '../stores/issue-panel';
import ContentProblemPanel from './ContentProblemPanel.vue';
import IssuePanel from './IssuePanel.vue';
import PlayerFilesPanel from './PlayerFilesPanel.vue';

const CONTENT_CODES = new Set<string>(['CONTENT_BROKEN', 'MEDIA_FILE_MISSING']);
const files = computed(() => (openIssue.value?.code === 'PLAYER_FILES_FAILED' ? openIssue.value : null));
const content = computed(() => (openIssue.value && CONTENT_CODES.has(openIssue.value.code) ? openIssue.value : null));
const other = computed(() => (openIssue.value && !files.value && !content.value ? openIssue.value : null));
const close = () => (openIssue.value = null);
/** "Details" on one failed file: that item's problem (as the Health Check list does). */
function openFile(assetId: string, name: string): void {
  const f = openIssue.value!;
  const ids = String(f.details.assetIds ?? '').split(',');
  const reason = String(f.details.reasons ?? '').split(',')[ids.indexOf(assetId)] ?? '';
  openIssue.value = { ...f, code: 'CONTENT_BROKEN', subjectId: assetId, subjectName: name, details: { reason, players: 1, playerNames: f.subjectName } } as HealthIssue;
}
</script>

<template>
  <ContentProblemPanel :issue="content" @close="close" @changed="close" />
  <PlayerFilesPanel :issue="files" @close="close" @open="openFile" />
  <IssuePanel :issue="other" @close="close" />
</template>
